/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FinancialStatementBasicData } from '../models/FinancialStatementBasicData';
import type { FinancialStatementFullRead } from '../models/FinancialStatementFullRead';
import type { FinancialStatementFullWrite } from '../models/FinancialStatementFullWrite';
import type { FinancialStatementSmall } from '../models/FinancialStatementSmall';
import type { FinancialStatementVersionValidator } from '../models/FinancialStatementVersionValidator';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FinancialsService {
    /**
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageCreate(
        data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/financials/financial_page/',
            body: data,
        });
    }
    /**
     * @param cmdPk
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageFinancialRfydRead(
        cmdPk: string,
    ): CancelablePromise<FinancialStatementFullWrite> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/financials/financial_page/{cmd_pk}/financial_rfyd/',
            path: {
                'cmd_pk': cmdPk,
            },
        });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @returns FinancialStatementFullRead
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageRead(
        id: number,
    ): CancelablePromise<FinancialStatementFullRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/financials/financial_page/{id}/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageCreate1(
        id: number,
        data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/financials/financial_page/{id}/',
            path: {
                'id': id,
            },
            body: data,
        });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageUpdate(
        id: number,
        data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/financials/financial_page/{id}/',
            path: {
                'id': id,
            },
            body: data,
        });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPagePartialUpdate(
        id: number,
        data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/financials/financial_page/{id}/',
            path: {
                'id': id,
            },
            body: data,
        });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @returns void
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageDelete(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/financials/financial_page/{id}/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @param data
     * @returns FinancialStatementFullRead
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageCreateVersionCreate(
        id: number,
        data: FinancialStatementVersionValidator,
    ): CancelablePromise<FinancialStatementFullRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/financials/financial_page/{id}/create_version/',
            path: {
                'id': id,
            },
            body: data,
        });
    }
    /**
     * @param mdPk
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageFinancialLtmNtmRead(
        mdPk: string,
    ): CancelablePromise<FinancialStatementFullWrite> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/financials/financial_page/{md_pk}/financial_ltm_ntm/',
            path: {
                'md_pk': mdPk,
            },
        });
    }
    /**
     * @param mdPk
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageFinancialsBasicDataListList(
        mdPk: string,
        page?: number,
    ): CancelablePromise<{
        count: number;
        next?: string | null;
        previous?: string | null;
        results: Array<FinancialStatementBasicData>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/financials/financial_page/{md_pk}/financials_basic_data_list/',
            path: {
                'md_pk': mdPk,
            },
            query: {
                'page': page,
            },
        });
    }
    /**
     * @param mdPk
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageGetByMeasurementDateRead(
        mdPk: string,
    ): CancelablePromise<FinancialStatementFullWrite> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/financials/financial_page/{md_pk}/get_by_measurement_date/',
            path: {
                'md_pk': mdPk,
            },
        });
    }
    /**
     * @param mdPk
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageGetByMeasurementDateUpdate(
        mdPk: string,
        data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/financials/financial_page/{md_pk}/get_by_measurement_date/',
            path: {
                'md_pk': mdPk,
            },
            body: data,
        });
    }
    /**
     * @param mdPk
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageGetByMeasurementDatePartialUpdate(
        mdPk: string,
        data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/financials/financial_page/{md_pk}/get_by_measurement_date/',
            path: {
                'md_pk': mdPk,
            },
            body: data,
        });
    }
    /**
     * @param mdPk
     * @param page A page number within the paginated result set.
     * @returns FinancialStatementSmall
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageListByMeasurementPeriodList(
        mdPk: string,
        page?: number,
    ): CancelablePromise<Array<FinancialStatementSmall>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/financials/financial_page/{md_pk}/list_by_measurement_period/',
            path: {
                'md_pk': mdPk,
            },
            query: {
                'page': page,
            },
        });
    }
}
